"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useObservable = void 0;
const react_1 = require("react");
// This hack forces React to re-render when `value` changes, even if the object
// reference has not changed. IE: Ignore result of `Object.is` optimization.
function useForceUpdate(initial) {
    const valueRef = (0, react_1.useRef)(initial);
    const [signal, setSignal] = (0, react_1.useState)(0);
    const setCallback = (0, react_1.useCallback)((v) => {
        valueRef.current = v;
        setSignal(s => s + 1);
    }, []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return [(0, react_1.useMemo)(() => valueRef.current, [signal]), setCallback];
}
function useObservable(observable) {
    const [value, setValue] = useForceUpdate(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const [done, setDone] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const subscription = observable.subscribe({
            next: setValue,
            error: setError,
            complete: () => setDone(true),
        });
        return () => subscription.unsubscribe();
        // Dependencies are un-necessary for this hook.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [value, error, done];
}
exports.useObservable = useObservable;
//# sourceMappingURL=rxjs.js.map